import { render, staticRenderFns } from "./CommunicationSkeleton.vue?vue&type=template&id=6ee9fa60&scoped=true&"
import script from "./CommunicationSkeleton.vue?vue&type=script&lang=js&"
export * from "./CommunicationSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationSkeleton.vue?vue&type=style&index=0&id=6ee9fa60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee9fa60",
  null
  
)

export default component.exports